export default "__VITE_ASSET__DLZZ60cX__"